import { render, staticRenderFns } from "./ModalSuppliers.vue?vue&type=template&id=65a9cf1a&lang=pug&"
import script from "./ModalSuppliers.vue?vue&type=script&lang=js&"
export * from "./ModalSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports